/* eslint-disable @typescript-eslint/no-empty-function */
import {
    Component,
    computed,
    effect,
    input,
    model,
    output,
} from "@angular/core";
import { BaseConfig } from "../common/config/config.adapter";
import { Size } from "../common/types";

@Component({
    selector: "app-checkbox-adapter",
    template: "",
})
export class CheckboxAdapter extends BaseConfig {
    label = input<string | null>("");
    description = input<string | null>("");
    class = input<string>("border-primary-500 bg-primary-500");
    disabled = input(false);

    $size = input<Size | null>(null, { alias: "size" });
    _size = computed(() => this.globalConfig()?.checkbox?.size);

    size = computed(() => this.$size() || this._size() || "md");

    checked = output<boolean>();

    modelValue = model<any>(null);
    value = model<boolean>(false);

    constructor() {
        super();

        effect(() => {
            this.onChange(this.value());
        });
    }

    toggle() {
        if (this.disabled()) return;
        this.value.set(!this.value());
        this.checked.emit(this.value());
        this.onChange(this.value());
    }

    writeValue(obj: any): void {
        this.value.set(!!obj);
    }
    registerOnChange(fn: any): void {
        this.onChange = fn;
    }
    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }
    setDisabledState?(isDisabled: boolean): void {}

    onChange = (value: any) => {};
    onTouched = () => {};
}
